import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class ProductCostConfigurationService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getProductDDByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProducts', data);
  }
  getUOMList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetUOM', data);
  }
}
